import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const fetchMetadata = async () => {
    return apiClient.get(ENDPOINTS.metadata);
};

export const useFetchMetadata = (options = {}) => {
    return useQuery({
        queryKey: queryKeys.metadata(),
        queryFn: fetchMetadata,
        ...options,
    });
};
